export default __webpack_public_path__ + "static/media/icon-bed.df66f2ef.svg";